export const getTotalPages = (totalCount: number, perPageCount: number) =>
  Math.ceil(totalCount / perPageCount)
